<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if (accessLoader) {
<div class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
}
@if (UserModuleAccess=='Full' && user_type=='cdm') {
<div class="card">
	<div class="card-body">
		<h2 class="card-title">
			{{pagetitle}}
			<a class="btn btn-sm btn-outline-success float-end" [routerLink]="['/app/create-vessel']">
				<fa-icon [icon]="['fas', 'plus']"></fa-icon>
				Create Vessel
			</a>
			<button class="btn btn-sm btn-outline-primary float-end me-1" (click)="updateVesselInventory()">
				@if (updateInventoryLoader) {
				<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
				}
				Update Inventory
			</button>
			<button class="btn btn-sm btn-outline-info float-end me-1" (click)="downloadExcel()">
				<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'" *ngIf="excelLoader"></fa-icon>
				<fa-icon [icon]="['fas', 'cloud-download-alt']" *ngIf="!excelLoader"></fa-icon>
				Download Excel
			</button>
			<button class="btn btn-sm btn-outline-warning float-end me-1" (click)="openExcelUploadModal()">
				<fa-icon [icon]="['fas', 'upload']"></fa-icon>
				Upload Excel
			</button>
			<!-- <a class="btn btn-sm btn-outline-warning float-end me-1" [routerLink]="['/app/sync-vessels']">
				<fa-icon [icon]="['fas', 'sync']"></fa-icon>
				Sync Vessels
			</a> -->
		</h2>
		<div class="row">
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-6 mt-1">
				<ng-select appearance="outline" appendTo="body" [items]="platform_dropdown" bindLabel="name"
					bindValue="val" [clearable]="true" [multiple]="false" [(ngModel)]="filter.platform"
					placeholder="Platform" (change)="refreshTable();">
				</ng-select>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-6 col-xs-6 mt-1">
				<ng-select appearance="outline" appendTo="body" [items]="companyList_dropdown" bindLabel="name"
					bindValue="id" [clearable]="true" [multiple]="false" [(ngModel)]="filter.company"
					placeholder="Company" (change)="rma_dashboard_fleet_dropdown();refreshTable();">
				</ng-select>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mt-1">
				<ng-select appearance="outline" appendTo="body" [items]="fleetList_dropdown" bindLabel="name"
					bindValue="id" [clearable]="true" [multiple]="false" [(ngModel)]="filter.fleet" placeholder="Fleet"
					(change)="refreshTable();">
				</ng-select>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mt-1">
				<ng-select appearance="outline" appendTo="body" [items]="ownerList" bindLabel="name" bindValue="id"
					[clearable]="true" [multiple]="false" [(ngModel)]="filter.owner" placeholder="Owner"
					(change)="refreshTable();">
				</ng-select>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="table-responsive">
					<table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered table-hover"
						style="width: 100%;">
						<thead>
							<tr class="table_head">
								<th style="width: 10% !important;">Company</th>
								<th style="width: 9% !important;">Fleet</th>
								<!-- <th style="width: 10% !important;">Owner</th> -->
								<th style="width: 10% !important;">Vessel</th>
								<th style="width: 9% !important;">Mail Sent</th>
								<th style="width: 9% !important;">Call Done</th>
								<th style="width: 8% !important;">Email</th>
								<th style="width: 6% !important;">Created At</th>
								<th style="width: 5% !important;" class="text-center">Shore Care</th>
								<th style="width: 5% !important;" class="text-center">HC</th>
								<th style="width: 5% !important;" class="text-center">MHS</th>
								<th style="width: 5% !important;" class="text-center">Pharma</th>
								<th style="width: 5% !important;" class="text-center">Training</th>
								<th style="width: 5% !important;" class="text-center">DOC User</th>
								<th style="width: 9% !important;">Action</th>
							</tr>
						</thead>
						<tbody *ngIf="dataList?.length != 0">
							<tr *ngFor="let v of dataList;let i = index;">
								<td>{{ v.company?v.company.name:"-" }}</td>
								<td>{{ v.fleet?v.fleet.name:"-" }}</td>
								<!-- <td>{{ v.vessel_owner?v.vessel_owner.name:"-" }}</td> -->
								<td>{{ v.name }}</td>
								<td>{{ v.mail_timestamp }}</td>
								<td>{{ v.call_timestamp }}</td>
								<td>
									<span [matTooltip]="v.email">
										{{ clipText(v.email,20) }}
									</span>
								</td>
								<td>{{ v.created_at }}</td>
								<td class="text-center">
									<button *ngIf="v.clip_id" class="btn btn-sm btn-outline-danger"
										matTooltip="Delete from Shore Care" id="btnDeleteCLIP{{v.id1}}"
										(click)="deleteConfirmCLIP(v.id1,i)">
										<fa-icon *ngIf="showDeleteLoaderCLIP != i" [icon]="['fas', 'times']"></fa-icon>
										<fa-icon *ngIf="showDeleteLoaderCLIP == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
									<button *ngIf="!v.clip_id" class="btn btn-sm btn-outline-success"
										matTooltip="Create in Shore Care" id="btnCreateCLIP{{v.id1}}"
										(click)="createConfirmCLIP(v.id1,i)">
										<fa-icon *ngIf="showCreateLoaderCLIP != i" [icon]="['fas', 'flag']"></fa-icon>
										<fa-icon *ngIf="showCreateLoaderCLIP == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
								</td>
								<td class="text-center">
									<button *ngIf="v.hc_id" class="btn btn-sm btn-outline-danger"
										matTooltip="Delete from HC" id="btnDeleteHC{{v.id1}}"
										(click)="deleteConfirmHC(v.id1,i)">
										<fa-icon *ngIf="showDeleteLoaderHC != i" [icon]="['fas', 'times']"></fa-icon>
										<fa-icon *ngIf="showDeleteLoaderHC == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
									<button *ngIf="!v.hc_id" class="btn btn-sm btn-outline-success"
										matTooltip="Create in HC" id="btnCreateHC{{v.id1}}"
										(click)="createConfirmHC(v.id1,i)">
										<fa-icon *ngIf="showCreateLoaderHC != i" [icon]="['fas', 'flag']"></fa-icon>
										<fa-icon *ngIf="showCreateLoaderHC == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
								</td>
								<td class="text-center">
									<button *ngIf="v.mhs_id" class="btn btn-sm btn-outline-danger"
										matTooltip="Delete from MHS" id="btnDeleteMHS{{v.id1}}"
										(click)="deleteConfirmMHS(v.id1,i)">
										<fa-icon *ngIf="showDeleteLoaderMHS != i" [icon]="['fas', 'times']"></fa-icon>
										<fa-icon *ngIf="showDeleteLoaderMHS == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
									<button *ngIf="!v.mhs_id" class="btn btn-sm btn-outline-success"
										matTooltip="Create in MHS" id="btnCreateMHS{{v.id1}}"
										(click)="createConfirmMHS(v.id1,i)">
										<fa-icon *ngIf="showCreateLoaderMHS != i" [icon]="['fas', 'flag']"></fa-icon>
										<fa-icon *ngIf="showCreateLoaderMHS == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
								</td>
								<td class="text-center">
									<button *ngIf="v.pharma_id" class="btn btn-sm btn-outline-danger"
										matTooltip="Delete from Pharma" id="btnDeletePharma{{v.id1}}"
										(click)="deleteConfirmPharma(v.id1,i)">
										<fa-icon *ngIf="showDeleteLoaderPharma != i"
											[icon]="['fas', 'times']"></fa-icon>
										<fa-icon *ngIf="showDeleteLoaderPharma == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
									<button *ngIf="!v.pharma_id" class="btn btn-sm btn-outline-success"
										matTooltip="Create in Pharma" id="btnCreatePharma{{v.id1}}"
										(click)="createConfirmPharma(v.id1,i)">
										<fa-icon *ngIf="showCreateLoaderPharma != i" [icon]="['fas', 'flag']"></fa-icon>
										<fa-icon *ngIf="showCreateLoaderPharma == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
								</td>
								<td class="text-center">
									<button *ngIf="v.training_id" class="btn btn-sm btn-outline-danger"
										matTooltip="Delete from Training" id="btnDeleteTraining{{v.id1}}"
										(click)="deleteConfirmTraining(v.id1,i)">
										<fa-icon *ngIf="showDeleteLoaderTraining != i"
											[icon]="['fas', 'times']"></fa-icon>
										<fa-icon *ngIf="showDeleteLoaderTraining == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
									<button *ngIf="!v.training_id" class="btn btn-sm btn-outline-success"
										matTooltip="Create in Training" id="btnCreateTraining{{v.id1}}"
										(click)="createConfirmTraining(v.id1,i)">
										<fa-icon *ngIf="showCreateLoaderTraining != i"
											[icon]="['fas', 'flag']"></fa-icon>
										<fa-icon *ngIf="showCreateLoaderTraining == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
								</td>
								<td class="text-center">
									@if (v.doc_user) {
									<button class="btn btn-sm btn-outline-danger" matTooltip="Delete User"
										(click)="deleteConfirmUser(v.id,i)">
										<fa-icon *ngIf="showDeleteLoaderUser != i" [icon]="['fas', 'times']"></fa-icon>
										<fa-icon *ngIf="showDeleteLoaderUser == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
									<button class="btn btn-sm btn-outline-primary ms-1" matTooltip="Reset Password"
										(click)="resetDOCPassword(v.id)">
										@if (resetPassDOCLoader == v.id) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'lock']"></fa-icon>
										}
									</button>
									}@else {
									<button class="btn btn-sm btn-outline-success" matTooltip="Create User"
										(click)="createConfirmUser(v.id,i)">
										<fa-icon *ngIf="showCreateLoaderUser != i" [icon]="['fas', 'flag']"></fa-icon>
										<fa-icon *ngIf="showCreateLoaderUser == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
									}
								</td>
								<td>
									<button class="btn btn-sm btn-outline-success" matTooltip="Call Done"
										id="btnCall{{v.id1}}" (click)="setCalledDate(v.id,i)">
										<fa-icon *ngIf="showCallLoader != i" [icon]="['fas', 'phone-alt']"></fa-icon>
										<fa-icon *ngIf="showCallLoader == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
									<!-- <button class="btn btn-sm btn-outline-success ms-1" matTooltip="Send Welcome Mail"
										id="btnMail{{v.id1}}" (click)="openSendMailModal(v.id,i)">
										<fa-icon *ngIf="showMailLoader != i" [icon]="['fas', 'paper-plane']"></fa-icon>
										<fa-icon *ngIf="showMailLoader == i" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button> -->
									<a class="btn btn-sm btn-outline-success ms-1" matTooltip="Send Welcome Mail"
										id="btnMail{{v.id1}}" [routerLink]="['/app/welcome-mail',v.id1]">
										<fa-icon [icon]="['fas', 'paper-plane']"></fa-icon>
									</a>
									<a class="btn btn-sm btn-outline-primary ms-1" matTooltip="Edit"
										id="btnEdit{{v.id1}}" [routerLink]="['/app/edit-vessel',v.id1]">
										<fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
									</a>
									<button class="btn btn-sm btn-outline-danger ms-1" matTooltip="Delete"
										(click)="openDeleteVesselModal(v)">
										<fa-icon *ngIf="showDeleteLoader != v.id" [icon]="['fas', 'times']"></fa-icon>
										<fa-icon *ngIf="showDeleteLoader == v.id" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
									<button class="btn btn-sm btn-outline-info ms-1" matTooltip="Send QR code"
										(click)="sendQR(v)">
										<fa-icon *ngIf="showQRLoader != v.id" [icon]="['fas', 'qrcode']"></fa-icon>
										<fa-icon *ngIf="showQRLoader == v.id" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
									</button>
									<button class="btn btn-sm btn-outline-dark ms-1"
										matTooltip="Wellness QR code{{v.mhs_id?'':'(Not linked to MHS)'}}"
										(click)="open_MHS_QR_Modal(v)" [disabled]="!v.mhs_id">
										@if (showGetMHSQRLoader == v.id) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'qrcode']"></fa-icon>
										}
									</button>
									<button class="btn btn-sm btn-outline-warning ms-1" matTooltip="Name history"
										(click)="getVesselNameHistory(v)">
										@if (vesselNameHistoryLoader == v.id) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'list']"></fa-icon>
										}
									</button>
								</td>
							</tr>
						</tbody>
						<tbody *ngIf="dataList?.length == 0">
							<tr>
								<td colspan="14" class="text-center">No data found!</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}
<div class="modal fade" id="sendMailModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content" *ngIf="mailIndex !== null">
			<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="sendMail()" #modform1="ngForm">
				<div class="modal-header">
					<h4 class="modal-title" id="exampleModalLabel">Send Welcome Email</h4>
					<button type="button" class="btn-close" aria-label="Close" (click)="clearSendMailModal()"></button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-lg-6 col-md-6 col-sm-12">
							<label>Vessel: <strong>{{dataList[mailIndex].name}}</strong></label>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-12">
							<label>Email-Id: <strong>{{dataList[mailIndex].email}}</strong></label>
						</div>
					</div>
					<div class="row mt-3">
						<div class="col-lg-1 col-md-1 col-sm-1">
							<label class="mt-3">CC:</label>
						</div>
						<div class="col-lg-11 col-md-11 col-sm-11">
							<phone-email-input formControlName="cc_emails" [type]="'email'" [id]="'cc_emails'"
								[required]="f1.cc_emails.hasValidator(requiredValidator)" [hasError]="false"
								[errors]="f1.cc_emails.errors"></phone-email-input>
						</div>
					</div>
					<div class="row mt-3">
						<div class="col-lg-1 col-md-1 col-sm-1">
							<label class="mt-3">BCC:</label>
						</div>
						<div class="col-lg-11 col-md-11 col-sm-11">
							<phone-email-input formControlName="bcc_emails" [type]="'email'" [id]="'bcc_emails'"
								[required]="f1.bcc_emails.hasValidator(requiredValidator)" [hasError]="false"
								[errors]="f1.bcc_emails.errors"></phone-email-input>
						</div>
					</div>
					<div class="row mt-3">
						<div class="col-lg-1 col-md-1 col-sm-1"></div>
						<div class="col-lg-11 col-md-11 col-sm-11">
							<ng-select [items]="languages" bindLabel="name" bindValue="val" [clearable]="false"
								id="language" formControlName="language" placeholder="Language*"
								[appearance]="'outline'">
							</ng-select>
							<p *ngIf="showError1('language')" class="text-danger">
								<span *ngIf="f1.language.errors?.required">
									Required
								</span>
							</p>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" (click)="clearSendMailModal()">
						Cancel
					</button>
					<button type="submit" class="btn btn-primary">
						<fa-icon *ngIf="showMailLoader === null" [icon]="['fas', 'paper-plane']"></fa-icon>
						<fa-icon *ngIf="showMailLoader !== null" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						Send Mail
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="modal fade" id="mhsQRModal">
	<div class="modal-dialog modal-lg">
		<div class="modal-content" *ngIf="mhsQRVessel">
			<div class="modal-header">
				<h4 class="modal-title">QR Code</h4>
				<button type="button" class="btn-close" aria-label="Close" (click)="clear_MHS_QR_Modal()"></button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-lg-6 col-md-6 col-sm-12">
						<label>Vessel: <strong>{{mhsQRVessel?.name}}</strong></label>
					</div>
					<div class="col-lg-6 col-md-6 col-sm-12">
						<label>Email-Id: <strong>{{mhsQRVessel?.email}}</strong></label>
					</div>
				</div>
				@if (mhsQRVessel?.qrImageUrl) {
				<div class="row">
					<div class="col text-center">
						<img [src]="mhsQRVessel?.qrImageUrl" alt="QR Code" class="qr-code">
					</div>
				</div>
				}
				<!-- @if (mhsQRVessel?.decodedQrText) {
				<div class="row">
					<div class="col text-center">
						<a [href]="mhsQRVessel?.decodedQrText" target="_blank">
							{{mhsQRVessel?.decodedQrText}}
						</a>
						<fa-icon [icon]="['fas','copy']" role="button" class="ms-2" (click)="copyQRLink()"
							matTooltip="Copy to clipboard">
						</fa-icon>
					</div>
				</div>
				} -->
				<div class="row mt-2">
					<div class="col">
						<div class="input-group input-group-sm mb-2">
							<span class="input-group-text">
								CC
							</span>
							<tag-input [(ngModel)]="mhsQRVessel.cc_emails" class="form-control"
								id="mhsQRVessel_cc_emails" [placeholder]="mailIdPlaceholder"
								[secondaryPlaceholder]="mailIdPlaceholder" [separatorKeys]="[' ']" [editable]="false"
								[validators]="emailvalidators" [errorMessages]="emailerrormessages"
								[modelAsStrings]="true" [addOnPaste]="true" [pasteSplitPattern]="splitPattern"
								[separatorKeyCodes]="[13]">
							</tag-input>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" (click)="save_MHS_QR()">
					<fa-icon [icon]="['fas', 'cloud-download-alt']"></fa-icon>
					Download QR code
				</button>
				<button type="button" class="btn btn-primary" (click)="send_MHS_QR()"
					[disabled]="showSendMHSQRLoader == mhsQRVessel?.id || !mhsQRVessel?.email">
					@if (showSendMHSQRLoader == mhsQRVessel?.id) {
					<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					}@else {
					<fa-icon [icon]="['fas', 'paper-plane']"></fa-icon>
					}
					Send QR code
				</button>
				<button type="button" class="btn btn-light" (click)="clear_MHS_QR_Modal()">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="excelUploadModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<form class="form-horizontal" [formGroup]="createForm" (ngSubmit)="saveData()" #modform2="ngForm">
				<div class="modal-header">
					<h4 class="modal-title">Create Vessels</h4>
					<button type="button" class="btn-close" aria-label="Close"
						(click)="closeExcelUploadModal()"></button>
				</div>
				<div class="modal-body">
					<div class="row mb-3">
						<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<ng-select appendTo=".modal-body" [items]="companyList_dropdown" bindLabel="name"
								bindValue="id" [clearable]="true" [multiple]="false" id="company"
								formControlName="company" placeholder="Company*" (change)="getFleetList();"
								[appearance]="'outline'">
							</ng-select>
							<p *ngIf="showError2('company')" class="text-danger">
								<span *ngIf="f2.company.errors?.required">
									Required
								</span>
								<span *ngIf="f2.company.errors?.incorrect">
									{{customError2.company}}
								</span>
							</p>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<ng-select appendTo=".modal-body" [items]="fleetList" bindLabel="name" [clearable]="true"
								[multiple]="false" id="fleet" formControlName="fleet" placeholder="Fleet*"
								[appearance]="'outline'" (change)="getFleetDetails()">
							</ng-select>
							<p *ngIf="showError2('fleet')" class="text-danger">
								<span *ngIf="f2.fleet.errors?.required">
									Required
								</span>
								<span *ngIf="f2.fleet.errors?.incorrect">
									{{customError2.fleet}}
								</span>
							</p>
						</div>
					</div>
					<div class="row mb-3">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<ng-select appendTo=".modal-body" [items]="pocList" bindLabel="full_name" bindValue="id"
								[clearable]="true" [multiple]="true" id="poc" formControlName="poc" name="poc"
								placeholder="Contact Persons" [appearance]="'outline'">
							</ng-select>
							<p *ngIf="showError2('poc')" class="text-danger">
								<span *ngIf="f2.poc.errors?.required">
									Required
								</span>
								<span *ngIf="f2.poc.errors?.incorrect">
									{{customError2.poc}}
								</span>
							</p>
						</div>
					</div>
					<div class="row mb-3">
						<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
							<ng-select appendTo=".modal-body" [items]="ownerList" bindLabel="name" bindValue="id"
								[clearable]="true" [multiple]="false" id="owner" formControlName="owner"
								placeholder="Owner" [appearance]="'outline'">
							</ng-select>
							<p *ngIf="showError2('owner')" class="text-danger">
								<span *ngIf="f2.owner.errors?.required">
									Required
								</span>
								<span *ngIf="f2.owner.errors?.incorrect">
									{{customError2.owner}}
								</span>
							</p>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center">
							<ngx-file-drop dropZoneLabel="Drop file here" browseBtnLabel="Browse file"
								[multiple]="false" (onFileDrop)="fileSelected($event)">
								<ng-template multiple="false" ngx-file-drop-content-tmp
									let-openFileSelector="openFileSelector">
									<div style="text-align: center;">
										<button type="button" class="btn btn-outline-primary btn-sm"
											(click)="openFileSelector()">
											*Drop Or Browse file(Excel)
										</button>
										@if (createExcel) {
										<p class="mb-0">{{createExcel.name}}</p>
										}
									</div>
								</ng-template>
							</ngx-file-drop>
							<a class="btn btn-sm btn-primary mt-2" [href]="excel_template_url" target="_blank">
								Download Template
							</a>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-success">
						@if (showLoader2) {
						<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						}@else {
						<fa-icon [icon]="['fas', 'save']"></fa-icon>
						}
						Create from excel
					</button>
					<button type="button" class="btn btn-sm btn-secondary" (click)="closeExcelUploadModal()">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="modal fade" id="deleteVesselModal" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-md modal-dialog-centered">
		<div class="modal-content border-0 shadow">
			<form [formGroup]="deleteVesselForm" (ngSubmit)="deleteVessel()" #modform3="ngForm">
				<div class="modal-header bg-light border-bottom-0 py-3">
					<h5 class="modal-title text-danger fw-bold d-flex align-items-center gap-2">
						<fa-icon [icon]="['fas', 'exclamation-triangle']"></fa-icon>
						Delete Vessel
					</h5>
					<button type="button" class="btn-close" (click)="closeDeleteVesselModal()" aria-label="Close">
					</button>
				</div>
				<div class="modal-body px-4 py-3">
					@if (createErrorMessages && createErrorMessages.length) {
					<p class="text-success mb-1">
						Vessel deleted and new vessel created successfully but following errors occured while syncing?
					</p>
					<ol>
						@for (error of createErrorMessages; track $index) {
						<li class="text-danger mb-0">
							{{error}}
						</li>
						}
					</ol>
					}@else{
					<p class="text-muted mb-4">
						You are about to delete the vessel
						<span class="fw-semibold text-dark">
							"{{f3.existing_name.value}}"
						</span>.
						Would you like to create a replacement vessel?
					</p>
					<div class="mb-3">
						<label class="form-label fw-medium text-secondary small text-uppercase tracking-wider">Create
							Replacement Vessel?
						</label>
						<div class="d-flex gap-4 mt-1">
							<mat-radio-group (change)="changeNewNameValidation()" formControlName="create_new"
								class="d-flex gap-3">
								<mat-radio-button [value]="'Yes'" [color]="'primary'">Yes</mat-radio-button>
								<mat-radio-button [value]="'No'" [color]="'primary'">No</mat-radio-button>
							</mat-radio-group>
						</div>
						<p *ngIf="showError3('create_new')" class="text-danger small mt-1">
							<span *ngIf="f3.create_new.errors?.required">Required</span>
							<span *ngIf="f3.create_new.errors?.incorrect">{{customError3.create_new}}</span>
						</p>
					</div>
					@if (f3.create_new.value == "Yes") {
					<div class="mb-2 animate-fade-in">
						<div class="form-floating">
							<input class="form-control" [ngClass]="{'is-invalid':showError3('new_name')}" id="new_name"
								formControlName="new_name" placeholder="New Vessel Name">
							<label for="new_name">
								New Vessel Name *
							</label>
						</div>
						<p *ngIf="showError3('new_name')" class="text-danger small mt-1">
							<span *ngIf="f3.new_name.errors?.required">New vessel name is required.</span>
							<span *ngIf="f3.new_name.errors?.incorrect">{{customError3.new_name}}</span>
						</p>
					</div>
					}
					}
				</div>
				<div class="modal-footer bg-light border-top-0 px-4 py-3">
					@if (!createErrorMessages || !createErrorMessages.length) {
					<button type="button" class="btn btn-outline-secondary btn-sm px-3"
						(click)="closeDeleteVesselModal()">
						Cancel
					</button>
					<button type="submit" class="btn btn-danger btn-sm px-3 d-flex align-items-center gap-2"
						[disabled]="modform3.invalid || showLoader3">
						@if (showLoader3) {
						<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						} @else {
						<fa-icon [icon]="['fas', 'trash']"></fa-icon>
						}
						<span>
							{{ f3.create_new.value == 'Yes' ? 'Delete & Create New' : 'Confirm Delete' }}
						</span>
					</button>
					}@else {
					<button type="button" class="btn btn-outline-secondary btn-sm px-3"
						(click)="closeDeleteVesselModal()">
						OK
					</button>
					}
				</div>
			</form>
		</div>
	</div>
</div>
<div class="modal fade" id="nameHistoryModal" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-md modal-dialog-centered">
		<div class="modal-content border-0 shadow">
			<div class="modal-header bg-light border-bottom-0 py-3">
				<h5 class="modal-title fw-bold d-flex align-items-center gap-2">
					{{ historyVessel?.name }}
				</h5>
				<button type="button" class="btn-close" (click)="closeNameHistoryModal()" aria-label="Close">
				</button>
			</div>
			<div class="modal-body px-4 py-3">
				<table class="table">
					<thead>
						<tr>
							<th>
								Name
							</th>
							<th>
								Date
							</th>
						</tr>
					</thead>
					<tbody>
						@for (h of vesselNameHistory; track $index) {
						<tr>
							<td>
								{{ h.vessel_name }}
							</td>
							<td>
								{{ h.date }}
							</td>
						</tr>
						}@empty {
						<tr>
							<td colspan="2" class="text-center">
								No history found
							</td>
						</tr>
						}
					</tbody>
				</table>
			</div>
			<div class="modal-footer bg-light border-top-0 px-4 py-3">
				<button type="button" class="btn btn-outline-secondary btn-sm px-3" (click)="closeNameHistoryModal()">
					OK
				</button>
			</div>
		</div>
	</div>
</div>